export default {"src":"/_next/static/media/Arthritis and Joint Disorders.4d468639.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};